import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportBusinessWebsite } from 'dashboard/models/report/business-website';
import { ReportTemplate } from 'dashboard/models/report-template';

interface BusinessWebsiteProps {
  report: ReportBusinessWebsite;
  reportTemplate?: ReportTemplate;
  isRedacted: boolean;
}

export const BusinessWebsite = ({
  report: {
    attributes: {
      query: { 'business-name': businessName, website: website },
    },
  },
  isRedacted,
}: BusinessWebsiteProps) => {
  return (
    <AttributeGrid>
      <AttributeItem
        title='Business Name'
        value={businessName}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-business-website__term'
      />
      <AttributeItem
        title='Website'
        value={website}
        placeholder='N/A'
        isRedacted={isRedacted}
        dataTest='report-business-website__country-code'
      />
    </AttributeGrid>
  );
};
